// Vendors
import React from 'react';
// Components
import { LayoutComponent } from 'components/layout/layout.component';
// Contexts
import { ProofIncomeContextConsumerHOC } from './contexts/proof-income.context';
import { FetchErrorContextConsumerHOC } from 'contexts/fetch-error.context';
// Enumerations
import { ProofIncomeStatesEnumeration } from './enumerations/proof-income-states.enumeration';
// Constants
import {
  PROOF_INCOME_LAYOUT_ASSET_COMPONENT_PROPS,
  PROOF_INCOME_LAYOUT_COMPONENT_PROPS,
} from './constants/proof-income.constants';
// Hooks
import { useProofIncomeHook } from './hooks/proof-income.hook';
// Translations
import {
  PROOF_INCOME_TITLES,
  PROOF_INCOME_DESCRIPTIONS,
} from './translations/proof-income.translations';
// Views
import { ProofIncomeLandingView } from './views/landing/proof-income-landing.view';
import { ProofIncomeMethodView } from './views/method/proof-income-method.view';
// Utilities
import { getLayoutContentComponent } from './utils/proof-income.utils';

const ProofIncomeBaseContainer = (): React.JSX.Element => {
  const { proofIncomeState, ...restHook } = useProofIncomeHook();

  const ProofIncomeFlowComponent: React.FC = {
      [ProofIncomeStatesEnumeration.LANDING]: ProofIncomeLandingView,
      [ProofIncomeStatesEnumeration.METHOD]: ProofIncomeMethodView,
    }[proofIncomeState],
    LayoutContentStyledComponent = getLayoutContentComponent(proofIncomeState);

  return (
    <LayoutContentStyledComponent>
      <LayoutComponent
        {...{ ...PROOF_INCOME_LAYOUT_COMPONENT_PROPS, ...restHook }}
        assetId={PROOF_INCOME_LAYOUT_ASSET_COMPONENT_PROPS[proofIncomeState]}
        title={PROOF_INCOME_TITLES[proofIncomeState]}
        description={PROOF_INCOME_DESCRIPTIONS[proofIncomeState]}
      >
        <ProofIncomeFlowComponent />
      </LayoutComponent>
    </LayoutContentStyledComponent>
  );
};

const ProofIncomeContainer = ProofIncomeContextConsumerHOC(
  FetchErrorContextConsumerHOC(ProofIncomeBaseContainer)
);

export { ProofIncomeContainer };
